import { Text as ChakraText, HStack, StackProps } from "@chakra-ui/react"
import AvatarStack from "@pathwright/ui/src/components/avatar/AvatarStack"
import { MentorGroupSubscriptionFragment } from "@pathwright/graphql-client/src/generated"

function SimpleGroupSubscriptionMentorGroup({
  mentorGroup,
  ...stackProps
}: {
  mentorGroup: MentorGroupSubscriptionFragment
} & StackProps) {
  return (
    <HStack w="100%" justifyContent="space-between" {...stackProps}>
      <ChakraText as="strong">{mentorGroup.name}</ChakraText>
      {/* TODO: use newer Chakra-based avatar stack once feat/home-screen is merged in. */}
      <AvatarStack
        users={mentorGroup.memberships?.edges?.map((e) => e!.node!.user)}
        size="16px"
        itemOffset="0px"
      />
    </HStack>
  )
}

export default SimpleGroupSubscriptionMentorGroup
